<template>
  <div class="justify-center mx-auto p-4">
    <loading :status="loading"></loading>
    <template v-if="repair.id">
      <div class="w-full flex justify-between">
        <button @click="repair.id = null" class="btn btn-white">
          {{ $t('Back') }}
        </button>

       <!--  <button @click="printInvoice" class="btn btn-white">
          {{ $t('Print or download invoice') }}
        </button> -->
      </div>
      <div id="trackContainer">
        <div class="bg-purple-200 rounded-md my-2 p-3 border md:flex justify-between">
          <h4 class="text-1 font-bold tracking-wider">{{ $t('Invoice') }} #{{ repair.tracking }}</h4>
          <h4 class="text-1 font-bold tracking-wider">{{ $t('Total Amount') }} : {{ repair.charges | currency }}</h4>
          <h4 class="text-1 font-bold tracking-wider">{{ $t('Prepaid Amount') }} : {{ repair.pre_paid | currency }}</h4>
          <h4 class="text-1 font-bold tracking-wider text-red-500">{{ $t('Due Amount') }} : {{ repair.due | currency }}</h4>
        </div>
        <div class="mb-1 flex items-center">
          <label class="w-32 block font-bold text-xs uppercase tracking-wide">{{ $t('Status') }}</label>
          <span class="mr-4 inline-block">:</span>
          <div class="inline-flex items-center px-2.5 py-0.5 rounded-md text-sm font-medium bg-blue-100 text-blue-800">
            {{ repair.status ? $t('Complete') : $t('Pending') }}
          </div>
        </div>
        <div class="mb-1 flex items-center">
          <label class="w-32 block font-bold text-xs uppercase">
            {{ $t('Update at') }}
          </label>
          <span class="mr-4 inline-block">:</span>
          <div>{{ repair.updated_at }}</div>
        </div>
        <div class="mb-1 mt-4 flex items-center">
          <label class="w-32 block font-bold text-xs uppercase">
            {{ $t('Customer name') }}
          </label>
          <span class="mr-4 inline-block">:</span>
          <div>{{ repair.name }}</div>
        </div>
        <div class="mb-1 flex items-center">
          <label class="w-32 block font-bold text-xs uppercase">
            {{ $t('Device') }}
          </label>
          <span class="mr-4 inline-block">:</span>
          <div>{{ repair.device_name }}</div>
        </div>
        <div class="mb-1 flex items-center">
          <label class="w-32 block font-bold text-xs uppercase tracking-wide">{{ $t('IMEI') }}</label>
          <span class="mr-4 inline-block">:</span>
          <div>{{ repair.imei }}</div>
        </div>
        <div class="mb-1 flex items-center">
          <label class="w-32 block font-bold text-xs uppercase tracking-wide">{{ $t('Serial number') }}</label>
          <span class="mr-4 inline-block">:</span>
          <div>{{ repair.serial_number }}</div>
        </div>
        <div v-if="repair.message" class="mb-1 flex items-center">
          <label class="w-32 block font-bold text-xs uppercase tracking-wide">{{ $t('Repair feedback') }}</label>
          <span class="mr-4 inline-block">:</span>
          <div>{{ repair.message }}</div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="relative flex flex-col min-w-0 break-words w-full shadow-lg rounded-lg bg-purple-300">
        <form @submit.prevent="track">
          <div class="flex-auto p-5 lg:p-15">
            <h4 class="text-3xl font-semibold">
              {{ $t('Track repair order') }}
            </h4>
            <p class="leading-relaxed mt-1 mb-4 text-gray-600">
              {{ $t('Please enter your invoice tracking identity number to trace your repair order status.') }}
            </p>
            <div class="relative w-full mb-3 mt-8">
              <label class="block uppercase text-gray-700 text-xs font-bold mb-2" for="track_id">{{ $t('Enter track ID') }}</label>
              <input :placeholder="$t('Enter track ID')" class="form-input" id="track_id" required type="text" v-model="track_id" />
              <span v-if="errorMessage" class="px-1 text-red-500">{{ errorMessage }}.</span>
            </div>

            <div class="text-center mt-6">
              <button class="btn btn-secondary px-5 uppercase" type="submit">
                {{ $t('Track your order status') }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  name: 'repair-track',
  metaInfo() {
    return {
      title: this.$i18n.t('Track repair order status'),
      titleTemplate: `%s - ${this.$store.getters['app/getAppName']}`,
    };
  },
  data() {
    return {
      loading: false,
      track_id: null,
      errorMessage: null,
      repair: {
        id: null,
        due: 1,
      },
    };
  },
  mounted() {
    const pathArray = window.parent.location.pathname.split('/');
    if (pathArray[1] === 'track' && pathArray[2]) {
      this.track_id = pathArray[2];
      this.track();
    }
    if (this.$route.params.key) {
      this.track_id = this.$route.params.key;
      this.track();
    }
  },
  methods: {
    printInvoice() {
      this.$router.push(`/print/repair/${this.repair.uuid}`);
    },

    async track() {
      this.loading = true;
      if (this.$store.getters['app/getSettings'].recaptcha_enabled) {
        await this.$recaptchaLoaded();
        const token = await this.$recaptcha('login');
        this.submitTotrack({ track_id: this.track_id, captcha_hash: token });
      } else {
        this.submitTotrack({ track_id: this.track_id });
      }
    },
    submitTotrack(track) {
      axios
        .post(route('repair-order.track'), track)
        .then((response) => {
          if (response.data.repair) {
            this.repair = response.data.repair;
          } else {
            this.errorMessage = response.data.message;
            this.$notify({
              title: this.$i18n.t('Warning').toString(),
              text: response.data.message.toString(),
              type: 'warning',
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
